$('.delivery-area-set-form').on("submit", function (e) {
    e.preventDefault();

    var formData = $(this).serialize();

    $.ajax({
        type: 'GET',
        url: $(this).attr("action"),
        dataType: "json",
        data: formData,
        success: function (response) {

            if (typeof response.shopArea !== "undefined") {

                $('.delivery-area-name').text(response.shopArea);

            }

            $('#delivery-area-modal').modal('hide');

            App.prototype.notificationSuccess(translates.delivery_area_set);

            if (location.href.includes('/basket')){
                location.reload();
            }

        },
        error: function (response) {

            App.prototype.notificationError(translates.delivery_area_set_error);

        }
    });

});

$('.change-shop-area').click(function (e) {
    e.preventDefault();
    $('#delivery-area-modal').modal();
});

var el_deliveryAreaModal = $('#delivery-area-modal'),
    el_productDetailModal = $('#productDetailModal'),
    el_featureSelectionModal = $('#featureSelectionModal');

el_deliveryAreaModal.on("show.bs.modal", function () {

    if (el_productDetailModal.hasClass("show")) {

        $('#productDetailModal').css("z-index", "1039");

    }

    if (el_featureSelectionModal.hasClass("show")) {

        $('#featureSelectionModal').css("z-index", "1039");

    }

});

el_deliveryAreaModal.on("hidden.bs.modal", function () {

    if (el_productDetailModal.hasClass("show")) {

        $('#productDetailModal').css("z-index", "1041");

    }

    if (el_featureSelectionModal.hasClass("show")) {

        $('#featureSelectionModal').css("z-index", "1041");

    }

    if (el_productDetailModal.is(":visible") || el_featureSelectionModal.is(":visible")){

        $("body").addClass("modal-open");

    }

});


const selectCity = $('#select-city');

if (selectCity) {
    selectCity.on("change", function () {
        const areaSelector = $('#delivery-area-city-id-' + $(this).val());

        areaSelector.prop("required", true).removeClass('d-none');
        areaSelector.siblings().prop("required", false).addClass('d-none');
    });
    selectCity.trigger("change");
}
